import actions from './actions';
import getters from './getters';
import mutations from './mutations';
export var state = () => ({
  productAccordionItems: {
    description: true,
    complementary: false,
    additional: false,
    range: false,
    rse: false
  }
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};